import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtiquetaMarcopoloComponent } from './etiqueta-marcopolo.component';
import { BarcodeModule } from '../barcode/barcode.module';
import { QrCodeModule } from '../qr-code/qr-code.module';

@NgModule({
  declarations: [
    EtiquetaMarcopoloComponent
  ],
  imports: [
    CommonModule,
    BarcodeModule,
    QrCodeModule
  ],
  exports: [
    EtiquetaMarcopoloComponent
  ]
})
export class EtiquetaMarcopoloModule { }
